module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Db-Ga-Ha-Ia.e8b90487.png";